import { render, staticRenderFns } from "./PainelTransformaGov.vue?vue&type=template&id=1bb2016f"
import script from "./PainelTransformaGov.vue?vue&type=script&lang=js"
export * from "./PainelTransformaGov.vue?vue&type=script&lang=js"
import style0 from "./PainelTransformaGov.vue?vue&type=style&index=0&id=1bb2016f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports